<template>
	<div class="keyword">
		<form class="keyword__add" @submit.prevent="addKeyword">
			<table class="simple-table">
				<thead>
					<tr>
						<th class="keyword__name">이름</th>
						<th class="keyword__button">등록</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td class="keyword__name">
							<input
								type="text"
								class="input-text"
								placeholder="키워드를 입력하세요"
								v-model="keyword"
							/>
						</td>
						<td class="keyword__button">
							<button class="btn blue" type="submit">등록</button>
						</td>
					</tr>
				</tbody>
			</table>
		</form>

		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left keyword__section">
					<p class="keyword__total">등록 : {{ total }}건</p>
					<form
						class="keyword__search"
						@submit.prevent="searchKeyword"
					>
						<input
							type="text"
							class="input-text"
							placeholder="키워드를 입력하세요"
							v-model="searchKeywordName"
						/>
						<button class="btn" type="submit">검색</button>
					</form>
				</div>
				<div class="section__info__right">
					<div class="section__info__items">
						<Selector
							:option-list="limitList"
							v-model="limit"
							@input="getList"
						/>
					</div>
					<div class="section__info__items">
						<Selector
							:option-list="sortList"
							v-model="sort"
							@input="getSortList"
						/>
					</div>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>항번</th>
						<th>이름</th>
						<th>등록일시</th>
						<th>수정</th>
						<th>삭제</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="list in keywordList" :key="list.idKeyword">
						<td class="keyword__num">{{ list.idKeyword }}</td>
						<td>
							<input type="text" v-model="list.keywordText" />
						</td>
						<td class="keyword__date">{{ list.createDate }}</td>
						<td class="keyword__btn">
							<button
								class="btn blue"
								type="button"
								@click="modifyKeyword(list.idKeyword)"
							>
								수정
							</button>
						</td>
						<td class="keyword__btn">
							<button
								class="btn red"
								type="button"
								@click="deleteKeyword(list.idKeyword)"
							>
								삭제
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				slot="pagination"
				:totalItem="total"
				:offset="offset"
				:limit="limit"
				@to="onSearch($event.offset)"
			/>
		</ManagingSection>
	</div>
</template>
<script>
	import PaginationBox from '../../components/PaginationBox.vue';
	import { formattedDate } from '../../util';
	import ManagingSection from '../../components/layout/ManagingSection.vue';
	import Selector from '@/components/Selector.vue';

	export default {
		components: {
			PaginationBox,
			Selector,
			ManagingSection,
		},
		data() {
			return {
				keyword: '',
				limit: 10,
				offset: 0,
				keywordList: [],
				total: 0,
				limitList: [
					{ value: 10, name: '10개씩' },
					{ value: 20, name: '20개씩' },
					{ value: 30, name: '30개씩' },
					{ value: 40, name: '40개씩' },
					{ value: 50, name: '50개씩' },
				],
				sortList: [
					{ value: 1, name: '최신등록순' },
					{ value: 2, name: '이전등록순' },
					{ value: 3, name: '이름순' },
					{ value: 4, name: '이름역순' },
				],
				sort: 1,
				sortType: 'create_desc',
				searchKeywordName: '',
			};
		},
		created() {
			this.initializeQueryParams();
			this.getList();
		},
		methods: {
			async addKeyword() {
				try {
					if (!this.keyword) {
						alert('키워드를 입력해주세요');
						return;
					}
					const params = {
						keywordText: this.keyword,
					};
					await this.$axiosAdmin2.post('/api/common/keyword', params);
					alert('키워드가 추가되었습니다.');
					this.keyword = '';
					this.getList();
				} catch (error) {
					console.error(error);
					alert(
						'키워드 추가를 실패하였습니다. 계속적인 문제 발생시 개발팀에 문의주세요'
					);
				}
			},
			async searchKeyword() {
				this.offset = 0;
				this.getList();
			},
			onSearch(offset) {
				this.offset = offset;
				this.getList();
			},
			async getList() {
				const queryParams = this.getQueryParams().toString();
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/common/keywords?${queryParams}`
					);
					this.keywordList = data.data.map(item => {
						return {
							...item,
							createDate: formattedDate(item.createDate),
						};
					});
					this.total = data.contentTotal;
					this.setQuery();
				} catch (error) {
					console.error(error);
					alert(
						'리스트를 불러오는것을 실패하였습니다. 계속적인 문제 발생시 개발팀에 문의주세요'
					);
				}
			},
			initializeQueryParams() {
				const queryParams = this.$route.query;

				if (queryParams.limit) {
					this.limit = parseInt(queryParams.limit, 10);
				}
				if (queryParams.order) {
					this.sort = parseInt(queryParams.order, 10);
				}
				if (queryParams.keyword) {
					this.searchKeywordName = queryParams.keyword;
				}
				if (queryParams.offset) {
					this.offset = parseInt(queryParams.offset, 10);
				}
				this.getSortList();
			},
			setQuery() {
				const query = {
					limit: this.limit,
					offset: this.offset,
					order: this.sort,
					keyword: this.searchKeywordName,
				};
				const setQuery = Object.entries(query).reduce(
					(acc, [key, value]) => {
						if (value) {
							acc[key] = value;
						}
						return acc;
					},
					{}
				);

				this.$router.replace({ query: setQuery }).catch(() => {});
			},
			getSortList() {
				const sortList = {
					1: 'create_desc',
					2: 'create_asc',
					3: 'keywordText_desc',
					4: 'keywordText_asc',
				};
				this.sortType = sortList[this.sort] || 'create_desc';
				this.getList();
			},
			async deleteKeyword(id) {
				try {
					if (!confirm('정말 삭제하시겠습니까?')) return;
					await this.$axiosAdmin2.delete(`/api/common/keyword/${id}`);
					alert('키워드가 삭제되었습니다.');
					this.getList();
				} catch (error) {
					console.error(error);
					alert(
						'키워드 삭제를 실패하였습니다. 계속적인 문제 발생시 개발팀에 문의주세요'
					);
				}
			},
			async modifyKeyword(id) {
				try {
					const params = {
						idKeyword: id,
						keywordText: this.keywordList.find(
							item => item.idKeyword === id
						).keywordText,
					};
					await this.$axiosAdmin2.post('/api/common/keyword', params);
					alert('키워드가 수정되었습니다.');
					this.getList();
				} catch (error) {
					console.error(error);
					alert(
						'키워드 수정을 실패하였습니다. 계속적인 문제 발생시 개발팀에 문의주세요'
					);
				}
			},
			getQueryParams() {
				const params = new URLSearchParams({
					offset: this.offset,
					limit: this.limit,
					order: this.sortType,
					keyword: this.searchKeywordName,
				});
				return params;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.keyword {
		&__add {
			width: 1000px;
			margin: 10px auto 30px;
			text-align: center;
			.simple-table {
				th {
					background: linear-gradient(
						to top,
						#d3e1f1,
						#f4f7fa,
						#f4f7fa
					);
					border: solid 1px #d5dde6;
					text-align: center;
					padding: 0;
				}
				td {
					text-align: center;
				}
			}
			.keyword__name {
				width: 90%;
			}
		}
		&__total {
			margin-top: 30p;
			padding: 20px 0;
		}
		&__search {
			width: 500px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			gap: 10px;
		}
		&__section {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
		}
		&__num {
			width: 10%;
		}
		&__date {
			width: 10%;
		}
		&__btn {
			width: 10%;
		}

		&__paging {
			margin-top: 30px;
		}
	}
	::v-deep .section__info {
		align-items: flex-end;
	}
</style>
